import { Model } from '@vuex-orm/core';
import Zaui from '@/include/api';

export default class Product extends Model {
  static entity = 'products';

  get imageUrl() {
    return this.image ? this.image : require('@/assets/images/abstract.png');
  }

  get routeName() {
    return this.type;
  }

  static fields() {
    return {
      type: this.string(),
      percentageType: this.boolean(),
      id: this.number(),
      name: this.string(),
      description: this.string(),
      image: this.string(),
      category: this.number(),
      price: this.number(),
      linkedToTourId: this.number(),
      linkedToPackageId: this.number()
    };
  }

  static fetch(id, productItem) {
    return Zaui.product.get(id, null, productItem).then(data => {
      Product.insert({ data });

      // if (data.lang && data.lang.overrides) {
        // mergeAllLocaleMessages(data.lang.overrides);
      // }
    });
  }

  static fetchList(category, date) {
    return Zaui.product.list(category, date).then(data => {
      Product.insert({ data });
    });
  }

}